import React from "react";
import { ReactComponent as Immobiliare } from "assets/icons/immobiliare_brand.svg";
import { ReactComponent as Idealista } from "assets/icons/idealista_brand.svg";
import { ReactComponent as Wikicasa } from "assets/icons/wikicasa_brand.svg";
import { ReactComponent as Casa } from "assets/icons/casa_brand.svg";
import { ReactComponent as Mioaffitto } from "assets/icons/mioaffitto_brand.svg";
import { ReactComponent as Trovacasa } from "assets/icons/trovacasa_brand.svg";
import { ReactComponent as Subito } from "assets/icons/subito_brand.svg";
import { ReactComponent as Bakeca } from "assets/icons/bakeca_brand.svg";
import { ReactComponent as PlusFiftyPortali } from "assets/icons/plus_fifty_portali_brand.svg";
import { ReactComponent as Cambiocasa } from "assets/icons/cambiocasa_brand.svg";
import { ReactComponent as LuxuryeStyle } from "assets/icons/luxuryestyle_brand.svg";
import { ReactComponent as EAndV } from "assets/icons/e&v_brand.svg";
import { ReactComponent as JamesEdition } from "assets/icons/jamesedition_brand.svg";
import { ReactComponent as Affitto } from "assets/icons/affitto_brand.svg";
import { ReactComponent as Trovit } from "assets/icons/trovit_brand.svg";
import { ReactComponent as Tecnocasa } from "assets/icons/tecnocasa_brand.svg";
import { ReactComponent as CB } from "assets/icons/cb_brand.svg";
import InfiniteScroller from "components/Slider/InfiniteScroller";

const partners = [
  { id: 1, icon: Immobiliare },
  { id: 2, icon: Idealista },
  { id: 3, icon: Wikicasa },
  { id: 4, icon: Casa },
  { id: 5, icon: Mioaffitto },
  { id: 6, icon: Trovacasa },
  { id: 7, icon: Subito },
  { id: 8, icon: Bakeca },
  { id: 9, icon: PlusFiftyPortali },
  { id: 10, icon: Cambiocasa },
  { id: 11, icon: LuxuryeStyle },
  { id: 12, icon: EAndV },
  { id: 13, icon: JamesEdition },
  { id: 14, icon: Affitto },
  { id: 15, icon: Trovit },
  { id: 16, icon: Tecnocasa },
  { id: 17, icon: CB },
  { id: 18, icon: PlusFiftyPortali },
];

const PartnerLogo = ({ partner }) => {
  const { id, icon: Icon } = partner;

  return (
    <div
      data-partner-id={id}
      className="h-[52px] w-[115px] sm:h-[100px] md:h-[203px] md:w-[203px] rounded-[10px] bg-[#FFFFFF1A] flex items-center justify-center"
    >
      <Icon className="max-w-[90px] max-h-[24px] md:max-h-fit md:max-w-fit" />
    </div>
  );
};

const PartnarsSection = () => {
  return (
    <div className="bg-primary h-fit pb-[32px] pt-[42px] overflow-hidden flex-1">
      <div className="max-w-[1320px] mx-auto desktop:px-0  lg:px-6 px-0">
        <div className="flex px-5 lg:px-0 flex-col md:flex-row items-center justify-between space-y-[15px] md:space-y-0">
          <h2 className="text-white text-center md:text-start font-semibold text-[24px] md:text-[32px] w-full max-w-[600px] md:w-[390px] leading-[1.3] md:leading-[38.73px]">
            Oltre 200+ partner immobiliari in tutta Italia
          </h2>
          <p className="text-[14px] md:text-[20px] text-center md:text-start font-medium text-white leading-[24px] md:leading-[25.2px] w-full max-w-[600px] opacity-80 md:opacity-100 md:w-[407px]">
            Centinaia di siti immobiliari scannerizzati per trovare la casa
            ideale per te
          </p>
        </div>
      </div>
      <div className="mt-[15px] sm:mt-[20px] md:mt-[30px] lg:mt-[52px] flex-1 relative">
        <InfiniteScroller direction="right" speed="slow">
          {partners.slice(0, 9).map((partner) => (
            <PartnerLogo key={partner.id} partner={partner} />
          ))}
        </InfiniteScroller>
        <div className="md:h-[10px] h-[6px]" />
        <InfiniteScroller direction="left" speed="slow">
          {partners.slice(9).map((partner) => (
            <PartnerLogo key={partner.id} partner={partner} />
          ))}
        </InfiniteScroller>
      </div>
    </div>
  );
};

export default PartnarsSection;
